'use client';

import { ArrowLeftIcon } from 'lucide-react';
import Link from 'next/link';

/** 하단 CTA — 라벨과 동일하게 블로그 목록으로만 이동 (히스토리 back 아님). */
export default function BlogPostFooterBack() {
  return (
    <nav className='back-to-list' aria-label='Blog navigation'>
      <Link
        href='/blog'
        className='inline-flex items-center gap-2 text-accent font-semibold text-base px-6 py-3 rounded-lg backdrop-blur-sm transition-all duration-300 hover:opacity-90 hover:-translate-y-0.5'
        aria-label='Go to blog listing'
      >
        <ArrowLeftIcon className='w-4 h-4 shrink-0' aria-hidden />
        Back to Blog
      </Link>
    </nav>
  );
}
